import { getPlatformFromUrl } from "../../utils/platform-mapping";

interface AuthHeaderProps {
  title: string;
  subtitle?: string;
}

export const AuthHeader = ({ title, subtitle }: AuthHeaderProps) => {
  const platform = getPlatformFromUrl();
  return (
    <div className="flex flex-col items-center">
      <div className="mb-6">
        <img
          src={platform.logo}
          alt={platform.name}
          height={"auto"}
          width={90}
        />
      </div>
      <h1 className="text-3xl text-white mb-2">{title}</h1>
      {subtitle && <p className="text-[#e8eaed]">{subtitle}</p>}
    </div>
  );
};
